import { FC } from 'react';
import { CircleCheck } from 'lucide-react';
import { cn } from '@new/lib';

interface OnboardingStepProps {
  index: number;
  step: number;
  title: string;
  subtitle: string;
  totalSteps: number;
}

export const OnboardingStep: FC<OnboardingStepProps> = ({
  index,
  step,
  title,
  subtitle,
  totalSteps,
}) => {
  const isHighlighted = index <= step || step === totalSteps;

  return (
    <div className="flex flex-col lg:flex-row gap-1.5 lg:gap-3 items-center lg:items-start">
      <div className="w-[18px] lg:w-[26px] h-[18px] lg:h-[26px] flex items-center justify-center shrink-0">
        <CircleCheck
          size={42}
          strokeWidth={3}
          className={cn(
            'transition-colors duration-200',
            isHighlighted ? 'stroke-(--secondary-B1100)!' : 'stroke-(--neutral-white-NW600)!'
          )}
        />
      </div>

      <div className="flex flex-col gap-1.5">
        <h6
          className={cn(
            '[font-family:var(--font-arvo)]! text-[11px]! lg:[font-size:var(--fs-h6)]! leading-(--lh-h)! font-bold! m-0! text-center lg:text-left',
            isHighlighted ? 'text-(--neutral-black-NB1000)!' : 'text-(--neutral-white-NW600)!'
          )}
        >
          {title}
        </h6>

        <p
          className={cn(
            'hidden lg:flex [font-family:var(--font-montserrat)]! [font-size:var(--fs-p3)]! leading-(--lh-p)! font-medium! m-0!',
            isHighlighted ? 'text-(--neutral-black-NB900)!' : 'text-(--neutral-white-NW600)!'
          )}
          style={{ whiteSpace: 'pre-line' }}
        >
          {subtitle}
        </p>
      </div>
    </div>
  );
};
